// Credit Purchase Success Page
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../utils/api';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, Loader2, Sparkles, ArrowRight } from 'lucide-react';

export function CreditSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [creditBalance, setCreditBalance] = useState(0);

  useEffect(() => {
    loadBalance();
  }, []);

  const loadBalance = async () => {
    try {
      const data = await api.request('/credits/balance');
      setCreditBalance(data.credits || 0);
    } catch (err) {
      console.error('Failed to load balance:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-6 text-center">
          {loading ? (
            <div>
              <Loader2 className="w-12 h-12 animate-spin text-purple-600 mx-auto mb-4" />
              <p className="text-gray-600">Processing your purchase...</p>
            </div>
          ) : (
            <div>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-10 h-10 text-green-600" />
              </div>
              
              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Credits Purchased! 🎉
              </h1>
              
              <p className="text-gray-600 mb-6">
                Your craft editing credits have been added to your account.
              </p>

              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mb-6">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Sparkles className="w-5 h-5 text-purple-600" />
                  <span className="text-sm text-purple-900 font-semibold">Your Balance</span>
                </div>
                <div className="text-4xl font-bold text-purple-900">
                  {creditBalance}
                  <span className="text-lg font-normal text-purple-700"> credits</span>
                </div>
              </div>

              <div className="space-y-3">
                <Button
                  onClick={() => navigate('/dashboard')}
                  className="w-full bg-purple-600 hover:bg-purple-700 text-white"
                >
                  Go to Dashboard
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
                
                <button
                  onClick={() => navigate(-2)}
                  className="w-full text-purple-600 hover:text-purple-700 font-medium"
                >
                  Return to Editor
                </button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
